import { FaLinkedinIn } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../style/components-style/Footer.css";
import ToggleLanguageButton from "../components/button/ToggleLanguageButton";
import ThemeButton from "../components/button/ThemeButton";

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer-bar">
      <div className="footer-container">
        {/* Left: Toggles */}
        <div className="footer-bar-left">
          <ToggleLanguageButton />
          <ThemeButton />
        </div>

        {/* Center: Copyright */}
        <p className="footer-bar-copy">{t("© 2026 Arivu | All Rights Reserved.")}</p>

        {/* Right: LinkedIn */}
        <a 
          href="https://www.linkedin.com/company/vrtta/" 
          target="_blank" 
          rel="noreferrer" 
          className="footer-pill-btn footer-bar-linkedin"
        >
          <FaLinkedinIn />
        </a>
      </div>
    </footer>
  );
}


export default Footer;
